<div id="wrap" [@casePracticeTeamQuestionAnimation] *ngIf="questions">
    <!-- <img src="{{assetsRoute}}/picture/casepracticeteam/bg.png" id="videoShortCut"> -->
    <div id="reviewBtn" class="casePracticeTeamQuestion fontSize16" (click)="goToVideo()">
        前情动画
    </div>
    <div id="questionsContent" class="casePracticeTeamQuestion">
      <div id="text" class="fontSize16 lineHeight24">
          请你帮周明诊断下，这6个问题都是哪些因素出了问题了呢？
      </div>
      <div id="correct" [@correctShowAnimation]="correctShow ? 'showCorrect' : 'hideCorrect'" class="fontSize18">
          <img style="width: 2.3rem;height: 2.3rem;" src="{{assetsRoute}}/picture/casepracticeauthorization/right.png">
      </div>
      <div [@questionShowAnimation]="questionShow ? 'showQuestion' : 'hideQuestion'" id="questionShowWrap">
        <div class="circle fontSize18" id="circle0" (click)="onItemClick(0, $event)" [ngClass]="{'circleNoAnswer':recordArray[0] == 0,'circleCorrectAnswer':recordArray[0] == 1,'circleWrongAnswer':recordArray[0] == 9,'circleCorrectAnswerTip':recordArray[0] == 10}">
            信任
        </div>
        <div class="circle fontSize18" id="circle1" (click)="onItemClick(1, $event)" [ngClass]="{'circleNoAnswer':recordArray[1] == 0,'circleCorrectAnswer':recordArray[1] == 1,'circleWrongAnswer':recordArray[1] == 9,'circleCorrectAnswerTip':recordArray[1] == 10}">
            承诺
        </div>
        <div class="circle fontSize18" id="circle2" (click)="onItemClick(2, $event)" [ngClass]="{'circleNoAnswer':recordArray[2] == 0,'circleCorrectAnswer':recordArray[2] == 1,'circleWrongAnswer':recordArray[2] == 9,'circleCorrectAnswerTip':recordArray[2] == 10}">
            沟通
        </div>
        <div class="circle fontSize18" id="circle3" (click)="onItemClick(3, $event)" [ngClass]="{'circleNoAnswer':recordArray[3] == 0,'circleCorrectAnswer':recordArray[3] == 1,'circleWrongAnswer':recordArray[3] == 9,'circleCorrectAnswerTip':recordArray[3] == 10}">
            流程
        </div>
        <div class="circle fontSize18" id="circle4" (click)="onItemClick(4, $event)" [ngClass]="{'circleNoAnswer':recordArray[4] == 0,'circleCorrectAnswer':recordArray[4] == 1,'circleWrongAnswer':recordArray[4] == 9,'circleCorrectAnswerTip':recordArray[4] == 10}">
            结果
        </div>
        <img src="{{assetsRoute}}/picture/casepracticeteam/group1.png" alt="" id="star0">
        <img src="{{assetsRoute}}/picture/casepracticeteam/group2.png" alt="" id="star1">
        <img src="{{assetsRoute}}/picture/casepracticeteam/group3.png" alt="" id="star2">
        <img src="{{assetsRoute}}/picture/casepracticeteam/group4.png" alt="" id="star3">
        <img src="{{assetsRoute}}/picture/casepracticeteam/group5.png" alt="" id="star4">
        <div id="questionWrap">
          <div id="question" class="fontSize18 lineHeight27">
            {{questions[currentNumber-1].question}}
          </div>
        </div>
      </div>

    </div>
    <div id="nextStep" class="fontSize18" (click)="goToBegin()">
        进入下一环节
    </div>

    <!--<img src="{{assetsRoute}}/picture/casepracticeteam/group5.png" alt="" id="star5">-->
</div>



// WEBPACK FOOTER //
// ./src/app/case-practice-team-question/case-practice-team-question.component.html